import { render, staticRenderFns } from "./TableFailures.vue?vue&type=template&id=4863eba8&"
import script from "./TableFailures.vue?vue&type=script&lang=js&"
export * from "./TableFailures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports